export const LEASE = 'lease';
export const FINANCE = 'finance';
export const CASH = 'cash';
export const CASH_PURCHASE = 'cashPurchase';
export const FINANCE_WITH_BALLOON = 'financeWithBalloon';
export const SINGLE_PAYMENT_LEASE = 'singlePaymentLease';

export default {
    LEASE,
    FINANCE,
    CASH,
    CASH_PURCHASE,
    FINANCE_WITH_BALLOON,
    SINGLE_PAYMENT_LEASE,
};
